import { createSlice } from '@reduxjs/toolkit';
import { ApiPaginationResponse } from 'src/components/ui/Table/Table.interface';
import {
  SERVICE_ACCOUNT_SLICE,
  setAutoAssignServiceAccountList,
  setServiceAccountDetails,
  setServiceAccountList,
  setServiceAccountStatus,
} from 'src/store/actions/serviceAccountActions';
import { ServiceAccount } from 'src/store/models/ServiceAccount';

export interface ServiceAccountState {
  serviceAccountList: ApiPaginationResponse<ServiceAccount[]>;
  serviceAccountDetails: ServiceAccount;
  autoAssignList: ApiPaginationResponse<ServiceAccount[]>;
}

const initialState: ServiceAccountState = {
  serviceAccountList: {
    data: [],
    count: 0,
    ctx: null,
  },
  serviceAccountDetails: null,
  autoAssignList: {
    data: [],
    count: 0,
    ctx: null,
  },
};

const serviceAccountSlice = createSlice({
  name: SERVICE_ACCOUNT_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setServiceAccountList, (state, action) => {
        state.serviceAccountList = action.payload;
      })
      .addCase(setAutoAssignServiceAccountList, (state, action) => {
        state.autoAssignList = action.payload;
      })
      .addCase(setServiceAccountDetails, (state, action) => {
        state.serviceAccountDetails = action.payload;
      })
      .addCase(setServiceAccountStatus, (state, action) => {
        const service = state.serviceAccountList.data?.find(
          (s) => s.id === action.payload?.service?.id
        );
        if (service) {
          service.enabled = action.payload?.enabled;
        }
      });
  },
});

export default serviceAccountSlice.reducer;
